/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Tools_Restrict_LabelInputs */



/**
* | output |
* | --- |
* | "Restrict to selected tools" |
*
* @param {Integrations_Apis_Tools_Restrict_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_tools_restrict_label = /** @type {((inputs?: Integrations_Apis_Tools_Restrict_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Tools_Restrict_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf ausgewählte Werkzeuge beschränken")
	return /** @type {LocalizedString} */ ("Restrict to selected tools")
});